import { InstanceService } from "./../../instance/models/instance.service";
import { InstanceModel } from "./../../instance/models/instance.model";
import { TranslateService } from "./../../shared/translate/translate.service";
import { PersonService } from "./../../person/models/person.service";
import { PersonModel } from "./../../person/models/person.model";
import { AuthService } from "./../../shared/models/auth.service";
import {
  WeGoConfig,
  ApplicationRouteURL,
  DataListModel,
  RoleLevel
} from "./../../shared/config";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FileUploader } from "ng2-file-upload";
import { AuthGuard } from "../../shared/guard/auth-guard.service";
import { DropdownModel } from "../../report/models/report-filter.model";

@Component({
  selector: "wego-import-person-csv",
  template: require('../views/import-person-csv.component.html'),
  providers: [PersonService, InstanceService]
})
export class ImportPersonCsvComponent implements OnInit {
  DataListModel: DataListModel;
  public headers: any;
  public uploader: FileUploader;
  public listOfRecord: any[];
  public listOfFilterRecord: any[];
  public csvValidationMsg: string;
  public popupMsg: string;
  public urlDefaultPage: string;
  public urlPersonList: string;
  module: string;
  breadCrumbList: string;
  isLoading: boolean;
  instanceHashId: string = "";
  instanceList: DropdownModel[];
  isParentCheck: boolean;
  roleLevel = RoleLevel;

  @ViewChild("csvFile") public csvFile: any;
  @ViewChild("successPopup") public successPopup: any;

  constructor(
    private authService: AuthService,
    private personService: PersonService,
    private instanceService: InstanceService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlPersonList = this.authService.GetURL(
      ApplicationRouteURL.URL_PERSON_LIST
    );
    this.module = this.translate.instant("LblPerson");
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
    this.ResetPaging();
    this.headers = this.authService.GetHeaderForFile();
    this.uploader = new FileUploader({
      url: WeGoConfig.API_VALIDATE_PERSON_CSV,
      headers: this.headers
    });
    this.uploader.onAfterAddingFile = (fileItem: any) =>
      this.HandleOnAfterAddingFile(fileItem);
    this.uploader.onBuildItemForm = (fileItem: any, Form: any) =>
      this.HandleOnBuildItemForm(fileItem, Form);
    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: any,
      headers: any
    ) => this.HandleOnCompleteItem(item, response, status, headers);

    this.GetInstanceList();
  }

  get ValidFormData() {
    if (this.uploader.queue.length > 0 && this.instanceHashId != "")
      return true;
    else return false;
  }

  get ValidImportRecord() {
    if (
      this.listOfRecord &&
      this.listOfRecord.length > 0 &&
      this.listOfRecord.filter(x => x.isValidRecord).length > 0
    )
      return true;
    else return false;
  }

  get isAnyChecked(): boolean {
    if (this.listOfRecord) {
      let isCheck = this.listOfRecord
        .filter(x => x.isValidRecord)
        .some(x => x.sendActivationLinkToImportedPerson == true);
      if (isCheck) {
        if (
          this.listOfRecord
            .filter(x => x.isValidRecord)
            .every(x => x.sendActivationLinkToImportedPerson == true)
        )
          this.isParentCheck = true;
        else this.isParentCheck = false;
      } else {
        this.isParentCheck = false;
      }

      return isCheck;
    } else {
      this.isParentCheck = false;
      return false;
    }
  }

  public OnParentCheck(isChecked: boolean) {
    this.listOfRecord
      .filter(x => x.isValidRecord)
      .forEach(x => (x.sendActivationLinkToImportedPerson = isChecked));
  }

  public GetInstanceList() {
    this.instanceService.GetImportAllowedInstance().subscribe(
      res => {
        this.instanceList = res.data;
        // this.instanceHashId = this.instanceList && this.instanceList.length > 0 ?
        //                       this.instanceList[0].instanceHashId : '';

        if (this.instanceList && this.instanceList.length > 0) {
          if (!this.instanceHashId && this.instanceList.length == 1) {
            this.instanceHashId = this.instanceList[0].keyHash;
          }
        }
      },
      error => {
        this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public ValidateCSV() {
    this.isLoading = true;
    this.uploader.uploadAll();
  }

  public ImportCSV() {
    this.isLoading = true;
    this.ImportPersonRecord();
  }

  public ImportPersonRecord() {
    let validPersonList = this.listOfRecord.filter(x => x.isValidRecord);
    this.personService.ImportPersonRecord(validPersonList).subscribe(
      res => {
        console.log(res);
        if (res.data) {
          let module = this.translate.instant("LblPerson");
          this.popupMsg = this.translate.instant("LblRecordImportedSuccess", [
            module
          ]);
          this.ShowSuccessPopup();
        } else {
          this.csvValidationMsg = res.error;
        }
        this.listOfRecord = [];
        this.instanceHashId = "";
        this.isLoading = false;
        this.ResetPaging();
      },
      error => {
        this.csvValidationMsg = this.authService.HandleErrorStatusCode(error);
        this.listOfRecord = [];
        this.instanceHashId = "";
        this.isLoading = false;
        this.ResetPaging();
      }
    );
  }

  public OnInstanceTypeChange() {
    // this.ClearFileInput();
    this.listOfRecord = [];
    this.ResetPaging();
  }

  public ClearFileInput() {
    console.log(this.csvFile);
    if (this.csvFile.nativeElement) {
      console.log(this.csvFile.nativeElement.value);
      this.csvFile.nativeElement.value = "";
      this.uploader.clearQueue();
    }
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.FilterList();
  }

  public FilterList() {
    let start =
      this.DataListModel.itemsPerPage * (this.DataListModel.currentPage - 1);
    let end = start + this.DataListModel.itemsPerPage;
    this.listOfFilterRecord = this.listOfRecord.slice(start, end);
  }

  public ResetPaging() {
    this.DataListModel = new DataListModel();
    this.DataListModel.itemsPerPage = 100;
  }

  public HandleOnAfterAddingFile(fileItem: any) {
    if (this.uploader.queue.length > 1) {
      this.uploader.queue.forEach(element => {
        element.remove();
      });
    }
  }

  public HandleOnBuildItemForm(fileItem: any, Form: any) {
    Form.append("instanceHashId", this.instanceHashId);
  }

  public HandleOnCompleteItem(
    item: any,
    response: any,
    status: any,
    headers: any
  ) {
    //following method redirect to error page if error
    this.authService.HandleErrorStatusCode(status);

    this.ResetPaging();
    let apiresponse: any = JSON.parse(response);
    if (status == 200) {
      if (!apiresponse.error) {
        this.csvValidationMsg = "";
        this.listOfRecord = apiresponse.data;
        this.DataListModel.totalItems = apiresponse.totalRecords;
        this.FilterList();
      } else {
        this.csvValidationMsg = apiresponse.error;
        this.listOfRecord = [];
      }
    }
    this.isLoading = false;
    this.ClearFileInput();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/import-data/components/import-person-csv.component.ts